export default __webpack_public_path__ + "static/media/guy_making_coffee.1867935d.jpg";